import { useSearchParams, useNavigate } from 'react-router-dom'
import Header from '../components/Header'

// Landing page for the unsubscribe link in marketing emails. The backend
// (GET /unsubscribe) does the opt-out and redirects here with ?status=.
export default function Unsubscribed() {
const [params] = useSearchParams()
const navigate = useNavigate()
const status = params.get('status')
const map = {
ok: { icon: '✅', title: "You've been unsubscribed", body: "You won't get any more marketing emails from HireIt. You'll still receive emails about your bookings, payments and account." },
invalid: { icon: '⚠️', title: 'Invalid link', body: "We couldn't verify that unsubscribe link. Check you opened the whole link from your email, or email hello@hireitnow.au and we'll remove you." },
error: { icon: '⚠️', title: 'Something went wrong', body: "Please try the link again, or email hello@hireitnow.au and we'll remove you." },
}
const s = map[status] || map.error
return (
<div><Header />
<div className="container" style={{ padding: '3rem 1rem', textAlign: 'center' }}>
<div style={{ fontSize: 64, marginBottom: 16 }}>{s.icon}</div>
<h2>{s.title}</h2>
<p style={{ color: 'var(--text-muted)', marginBottom: 24, maxWidth: 480, marginLeft: 'auto', marginRight: 'auto' }}>{s.body}</p>
<button className="btn btn-primary" onClick={() => navigate('/')}>Back to HireIt</button>
</div>
</div>
)
}
